import React from 'react'
import { connect } from 'react-redux'
import LoginContainer from "./LoginContainer/LoginContainer";
import PrivateRoute from "../components/Routes/PrivateRoute";
import { Routes, Route, Navigate } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
import LoginRoute from '../components/Routes/LoginRoute';
import HomeContainer from './HomeContainer/HomeContainer';
import SystemsContainer from './SystemsContainer/SystemsContainer';
import { SHOW_METRICS } from '../helpers/features';


const NavigationContainer = (props) => {
  const { isAuthenticated, loading } = props;
  return (
    !loading
      ? (
        <Routes>
        <Route element={<LoginRoute isAuthenticated={isAuthenticated} loading={loading} />} >
          <Route path="/login" element={<LoginContainer />} />
        </Route>
        <Route element={<PrivateRoute isAuthenticated={isAuthenticated} loading={loading} />} >
          <Route exact path="/" element={<SystemsContainer />} />
          {SHOW_METRICS && <Route exact path="/dashboard" element={<HomeContainer />} />}
        </Route>

        {/* Unknown or disabled routes (e.g. /dashboard with SHOW_METRICS off) go to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      )
      : (
        <div className="contenedor-spinner">
          <Spinner color='blue' animation="border" role="status" size='25'>
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
  ));
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    loading: state.auth.loading,
  };
};

export default connect(mapStateToProps)(NavigationContainer)